type IconProps = React.SVGProps<SVGSVGElement>;

const User: React.FC<IconProps> = (props) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.25586 19.8739C2.04865 20.2326 2.17143 20.6913 2.53009 20.8985C2.88875 21.1057 3.34747 20.983 3.55468 20.6243L2.25586 19.8739ZM20.4455 20.6245C20.6527 20.9831 21.1115 21.1059 21.4701 20.8987C21.8288 20.6915 21.9516 20.2328 21.7444 19.8741L20.4455 20.6245ZM2.90527 20.2491L3.55468 20.6243C4.41093 19.1422 5.64212 17.9116 7.12457 17.056L6.74966 16.4064L6.37476 15.7568C4.66433 16.744 3.24379 18.1639 2.25586 19.8739L2.90527 20.2491ZM6.74966 16.4064L7.12457 17.056C8.60702 16.2004 10.2885 15.75 12.0002 15.75L12.0002 15L12.0002 14.25C10.0253 14.25 8.0852 14.7697 6.37476 15.7568L6.74966 16.4064ZM12.0002 15L12.0002 15.75C13.7118 15.75 15.3933 16.2005 16.8757 17.0561L17.2506 16.4065L17.6255 15.757C15.9151 14.7697 13.975 14.25 12.0002 14.25L12.0002 15ZM17.2506 16.4065L16.8757 17.0561C18.3581 17.9117 19.5893 19.1424 20.4455 20.6245L21.0949 20.2493L21.7444 19.8741C20.7565 18.1641 19.336 16.7442 17.6255 15.757L17.2506 16.4065ZM18.0001 9H17.2501C17.2501 11.8995 14.8996 14.25 12.0002 14.25V15V15.75C15.7281 15.75 18.7501 12.7279 18.7501 9H18.0001ZM12.0002 15V14.25C9.10065 14.25 6.75005 11.8995 6.75005 9H6.00005H5.25005C5.25005 12.7279 8.27226 15.75 12.0002 15.75V15ZM6.00005 9H6.75005C6.75005 6.1005 9.10056 3.75 12.0001 3.75V3V2.25C8.27213 2.25 5.25005 5.27208 5.25005 9H6.00005ZM12.0001 3V3.75C14.8995 3.75 17.2501 6.1005 17.2501 9H18.0001H18.7501C18.7501 5.27208 15.728 2.25 12.0001 2.25V3Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default User;
